var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "row header-content" }, [
    _c(
      "div",
      { staticClass: "col-2" },
      [
        _c("datepicker", {
          attrs: {
            "monday-first": true,
            language: _vm.datepickerDE,
            "bootstrap-styling": true
          },
          model: {
            value: _vm.selection.startDate,
            callback: function($$v) {
              _vm.$set(_vm.selection, "startDate", $$v)
            },
            expression: "selection.startDate"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-10" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-lg",
          class: _vm.selection.duration === "day" ? ["active"] : [],
          on: {
            click: function($event) {
              _vm.selection.duration = "day"
            }
          }
        },
        [_vm._v("1 Tag")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-lg",
          class: _vm.selection.duration === "week" ? ["active"] : [],
          on: {
            click: function($event) {
              _vm.selection.duration = "week"
            }
          }
        },
        [_vm._v("1 Woche")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-lg",
          class: _vm.selection.duration === "month" ? ["active"] : [],
          on: {
            click: function($event) {
              _vm.selection.duration = "month"
            }
          }
        },
        [_vm._v("1 Monat")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }